import React from "react";

import { useNavigate } from "react-router";

function CloseButton() {
  let navigate = useNavigate();

  function handleClick() {
    navigate(-1);
  }

  return (
    <img
      src={process.env.PUBLIC_URL + "/assets/imgs/arrow-left.svg"}
      alt="Back"
      className="back-arrow"
      style={{ cursor: "pointer" }}
      onClick={handleClick}
    />
  );
}

export default CloseButton;
